<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Client</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
     
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />
        <div class="vx-row mb-6" v-if="clientDescription.is_sole_trader">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Is Sole Trader:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.is_sole_trader }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="clientDescription.company_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Company Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.company_name }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.company_registration_number"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Company Registration Number:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.company_registration_number }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="clientDescription.status">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Company Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.status }}
          </div>
        </div>
                <div class="vx-row mb-6" v-if="clientDescription.company_category">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Company Category:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.company_category }}
          </div>
        </div>
        <div v-if="clientDescription.registered_office_address_1 || clientDescription.registered_office_address_2 || clientDescription.registered_office_address_3 || clientDescription.registered_office_city || clientDescription.registered_office_county || clientDescription.registered_office_country || clientDescription.registered_office_country">
<vs-divider class="m-5" />
        <!-- Registered Office -->
        <h5 class="mb-5">Registered Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.registered_office_address_1"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             
              Address Line 1:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.registered_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.registered_office_address_2"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.registered_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.registered_office_address_3"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              
              Address Line 3:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.registered_office_address_3 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.registered_office_city"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              
              City:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.registered_office_city }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.registered_office_county"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              
              County:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.registered_office_county }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.registered_office_postcode"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             
              Postcode:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.registered_office_postcode }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.registered_office_country"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             
              Country:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.registered_office_country }}
          </div>
        </div>

        <!-- Head Office -->
        <div v-if="clientDescription.head_office_address_1 || clientDescription.head_office_address_2 || clientDescription.head_office_address_3 || clientDescription.head_office_city || clientDescription.head_office_county || clientDescription.head_office_postcode">
                <vs-divider class="m-5" />
        <h5 class="mb-5">Head Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.head_office_address_1"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Address Line 1:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.head_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.head_office_address_2"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Address Line 2:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.head_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="clientDescription.head_office_address_3"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Address Line 3:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.head_office_address_3 }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="clientDescription.head_office_city">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             
              City:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.head_office_city }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="clientDescription.head_office_county">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             
              County:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.head_office_county }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="clientDescription.head_office_postcode">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Postcode:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.head_office_postcode }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="clientDescription.head_office_country">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             
              County:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientDescription.head_office_country }}
          </div>
        </div>
        <!-- <vs-divider class="m-5" /> -->
        <template
          v-if="clientDescription.web && clientDescription.web.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
             
              Company Website(s)
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="website_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + website_show_no + " entries" }}</span
            >
          </div>
          <div
            v-for="(website, web_key) in clientDescription.webShow"
            :key="web_key"
          >
            <span class="p-5">
              <p>{{ website.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <template
          v-if="
            clientDescription.linkedin &&
              clientDescription.linkedin.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
             
              Social Media Pages
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="linkedin_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + linkedin_show_no + " entries" }}</span
            >
          </div>
          <div
            v-for="(link, linkedin_key) in clientDescription.linkedinShow"
            :key="linkedin_key"
          >
            <span class="p-5">
              <p>{{ link.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <!-- Site Office -->
        <template
          v-if="
            clientDescription.satellite_office &&
              clientDescription.satellite_office.length > 0
          "
        >
          <h5 class="mb-5">Site Office Address</h5>
          <template
            v-for="(site, index) in clientDescription.satellite_office"
          >
            <div :key="index">
              <vs-divider class="m-5" />
              <h6 class="mb-5">{{ "Satellite Office " + (index + 1) }}</h6>
              <div class="vx-row mb-6" v-if="site.address_1">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    >
                    Address Line 1:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.address_1 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_2">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    >
                    Address Line 2:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.address_2 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_3">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    >
                    Address Line 3:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.address_3 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.city">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    >
                    City:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.city }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.county">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    >
                    County:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.county }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.postcode">
                <div class="vx-col sm:w-1/5 w-full">
                  <span
                    >
                    Postcode:</span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">{{ site.postcode }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.phone.length != 0">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>
                    Telephone:                    </span
                  >
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <template v-for="(phone, key) in site.phone">
                    <div :key="key" v-if="phone.satellite_office_id == site.id">
                      {{ phone.phone_no }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
                  <vs-divider class="m-5" />
        </template>

        <!-- Telephone -->
        <template
          v-if="clientDescription.phone && clientDescription.phone.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
            
              Telephone Number(s)
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="telephone_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + telephone_show_no + " entries" }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <template v-for="phone in clientDescription.phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <template v-if="p_type.type == 'head_office_switchboard'">
                      <p class="m-10">
                        Head Office Switchboard - {{ phone.phone_no }}
                      </p>
                    </template>
                    <template v-if="p_type.type == 'customer_service'">
                      <p class="m-10">
                        Customer Service - {{ phone.phone_no }}
                      </p>
                    </template>

                    <template v-if="p_type.type == 'sales_line'">
                      <p class="m-10">Sales Line - {{ phone.phone_no }}</p>
                    </template>

                    <template v-if="p_type.type == 'customer_support_line'">
                      <p class="m-10">
                        Customer Support Line - {{ phone.phone_no }}
                      </p>
                    </template>

                    <template v-if="p_type.type == 'others'">
                      <p class="m-10">
                        Others - {{ phone.phone_no }}
                      </p>
                    </template>
                  </template>
                </template>
              </template>
            </div>
            <div class="vx-col sm:w-1/3 w-full"></div>
          </div>
        </template>
        <!-- SIC CODE -->
         <template
          v-if="clientDescription.sic_code && clientDescription.sic_code.length > 0"
        >
          <div class="vx-row p-5">
            <h6 class="mr-5">
             
              Sic Code(s)
            </h6>
            <v-select
              label="name"
              :options="[5, 10, 20, 50]"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="sic_show_no"
            />
            <span class="p-2 text-grey">
              {{ "Showing " + sic_show_no + " entries" }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <template v-for="sic in clientDescription.sic_code">

                <p class="m-10">
                  {{ sic.name }}
                </p>
              </template>
            </div>
            <div class="vx-col sm:w-1/3 w-full"></div>
          </div>
        </template>
        <template
          v-if="
            clientDescription.registration_jurisdiction ||
              clientDescription.parent ||
              clientDescription.vertical || clientDescription.nda_completed || clientDescription.sow_completed || clientDescription.nda_due_by || clientDescription.sow_due_by
          "
        >
          <h5 class="mb-5">Other Details</h5>
                    <div
            class="vx-row mb-6"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                NDA Completed:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.nda_document?'Yes':'No' }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>

                        <div
            class="vx-row mb-6"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                SOW Completed:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.sow_document?'Yes':'No' }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>

          <div
            class="vx-row mb-6"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                Email Provided:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.email_host?'Yes':'No' }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>

                                  <div
            class="vx-row mb-6"
            v-if="clientDescription.nda_due_by"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                NDA Due By:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.nda_due_by }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>

          <div
            class="vx-row mb-6"
            v-if="clientDescription.sow_due_by"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                SOW Due By:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.sow_due_by }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>

                 <div
            class="vx-row mb-6"
            v-if="clientDescription.nda_expires_on"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                NDA Expires On:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.nda_expires_on }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>

                       <div
            class="vx-row mb-6"
            v-if="clientDescription.sow_expires_on"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                SOW Expires On:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.sow_expires_on }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>




          <div
            class="vx-row mb-6"
            v-if="clientDescription.email_host"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                Email Host:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.email_host }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>

                    <div
            class="vx-row mb-6"
            v-if="clientDescription.email_due_by"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                Email Due By:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ clientDescription.email_due_by }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>
                  <div class="vx-row p-5" v-if="clientDescription.nda_document">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              NDA Document:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-button
              @click="
                downloadNDAWithAxios(clientDescription.nda_document)
              "
              color="danger"
              type="border"
              >Download</vs-button
            >
          </div>
        </div>

              <div class="vx-row p-5" v-if="clientDescription.sow_document">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              SOW Document:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-button
              @click="
                downloadSOWWithAxios(clientDescription.sow_document)
              "
              color="danger"
              type="border"
              >Download</vs-button
            >
          </div>
        </div>


          <div
            class="vx-row mb-6"
            v-if="clientDescription.registration_jurisdiction"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                Registration Jurisdiction:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ RegistrationJurisdiction }}
              <!-- {{ clientDescription.registration_jurisdiction }} -->
            </div>
          </div>
          <div class="vx-row mb-6" v-if="clientDescription.parent">
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                Parent Company:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ parent_name }}
            </div>
          </div>
          <div class="vx-row mb-6" v-if="clientDescription.vertical">
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >
                Vertical:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- {{ clientDescription.vertical }} -->
              {{ verticalName }}
            </div>
          </div>
        </template>
        <h5 class="mb-5" v-if="groupCompanies.length > 0">
          Grouped Companies
        </h5>
        <Finder
          :theme="theme"
          style="cursor:pointer;"
          :key="componentKey"
          @expand="onExpand"
          :tree="companyTree"
        ></Finder>

        <!-- <div class="vx-row mb-6" v-if="groupCompanies.length > 0">
          <div class="vx-col sm:w-1/3 w-full">
            <template v-for="(company, key) in groupCompanies">
              <a target="blank" :key="key" :href="company.id"
                ><p class="mb-5">{{ company.company_name }}</p></a
              >
            </template>
          </div>
          <vs-divider class="m-5" />
        </div> -->
        <vs-row vs-w="12" class="mt-10">
          <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
            <template v-if="clientDescription.parent">
              <vs-button
                v-show="showGroupCompaniesButton"
                @click="showGroupCompanies"
                type="border"
                icon="search"
                color="danger"
                >Show Companies in this group</vs-button
              >
            </template>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="8"
            vs-sm="4"
            vs-xs="12"
          >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
   
          </vs-col>
        </vs-row>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import axios from "@/axios.js";
import defineAbilitiesFor from '@/config/abilities'
import _ from "lodash";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import vSelect from "vue-select";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import VxTimeline from "@/components/timeline/VxTimeline";
import { Finder } from "@jledentu/vue-finder";
import "@jledentu/vue-finder/dist/vue-finder.css";
import moment from "moment";
export default {
  data() {
    return {
                              abilities : null,

      satelliteOffices: [],
      showGroupCompaniesButton: true,
      componentKey: 0,
      satellitePopupActive: false,
      satelliteOfficeHistoryData: [],
      satelliteMetaTitle: null,
      satelliteMetadataName: null,
      masterMetadata: [],
      clientDescription: [],
      telephone_show_no: 5,
      sic_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      groupCompanies: [],
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      popupActive: false,
      MasterPopupActive: false,
      metadataName: null,
      metadata: [],
      metaTitle: null,
      companyTree: {},
      theme: {
        primaryColor: "rgba(255, 0, 0, 0.52)",
        arrowColor: "black",
        separatorColor: "#ccc",
        separatorWidth: "1px",
        dropZoneBgColor: "rgba(33, 150, 243, 0.2)",
        draggedItemBgColor: "rgba(33, 150, 243, 0.5)"
      }
    };
  },
  components: {
    "v-select": vSelect,
    ClientAutocomplete,
    VxTimeline,
    Finder
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
    if (!moduleClientsManagement.isRegistered) {
      this.$store.registerModule(
        "clientsManagement",
        moduleClientsManagement
      );
      moduleClientsManagement.isRegistered = true;
    }
    this.init();
  },
  watch: {
    website_show_no(val) {
      if (val) {
        this.clientDescription.webShow = this.clientDescription.web.slice(
          0,
          val
        );
      }
    },
    linkedin_show_no(val) {
      if (val) {
        this.clientDescription.linkedinShow = this.clientDescription.linkedin.slice(
          0,
          val
        );
      }
    },
    telephone_show_no(val) {
      if (val) {
        this.clientDescription.phone = this.clientDescription.phone.slice(
          0,
          val
        );
      }
    },
    sic_show_no(val) {
      if (val) {
        this.clientDescription.sic_code = this.clientDescription.sic_code.slice(
          0,
          val
        );
      }
    }
  },
  mounted() {},
  methods: {
        forceFileDownload(response, title) {
      // console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
        downloadNDAWithAxios(filename) {
      axios
        .get(`/api/clients/download_nda_upload/${filename}`)
        .then(response => {
          this.forceFileDownload(response, filename);
        })
        .catch(error => {
          console.log(error);
        });
    },
    downloadSOWWithAxios(filename) {
      axios
        .get(`/api/clients/download_sow_upload/${filename}`)
        .then(response => {
          this.forceFileDownload(response, filename);
        })
        .catch(error => {
          console.log(error);
        });
    },
    init() {
      const clientId = this.$route.params.clientId;
      this.$store
        .dispatch("clientsManagement/fetchClient", clientId)
        .then(res => {
          this.clientDescription = res.data;
          this.clientDescription.webShow = this.clientDescription.web.slice(
            0,
            this.website_show_no
          );
          this.clientDescription.linkedinShow = this.clientDescription.linkedin.slice(
            0,
            this.linkedin_show_no
          );
          this.clientDescription.phone = this.clientDescription.phone.slice(
            0,
            this.telephone_show_no
          );

        this.clientDescription.sic_code = this.clientDescription.sic_code.filter(function (e) {
          e.id = e.sic_code_detail.id
          e.name = e.sic_code_detail.code + ' - ' + e.sic_code_detail.description
          return e
        })
          this.clientDescription.sic_code = this.clientDescription.sic_code.slice(
            0,
            this.sic_show_no
          );
          if (this.clientDescription.parent) {
            this.showParentName(this.clientDescription.parent);
          }
          if (this.clientDescription.registration_jurisdiction) {
            this.showRegistrationJurisdiction(
              this.clientDescription.registration_jurisdiction
            );
          }
          if (this.clientDescription.vertical) {
            this.showVertical(this.clientDescription.vertical);
          }
           if (this.clientDescription.nda_due_by) {
            this.clientDescription.nda_due_by = moment(this.clientDescription.nda_due_by).format("DD/MM/YYYY")
          }
           if (this.clientDescription.sow_due_by) {
            this.clientDescription.sow_due_by = moment(this.clientDescription.sow_due_by).format("DD/MM/YYYY")
          }
            if (this.clientDescription.nda_expires_on) {
            this.clientDescription.nda_expires_on = moment(this.clientDescription.nda_expires_on).format("DD/MM/YYYY")
          }
            if (this.clientDescription.sow_expires_on) {
            this.clientDescription.sow_expires_on = moment(this.clientDescription.sow_expires_on).format("DD/MM/YYYY")
          }
             if (this.clientDescription.email_due_by) {
            this.clientDescription.email_due_by = moment(this.clientDescription.email_due_by).format("DD/MM/YYYY")
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    onExpand({ expanded, sourceEvent }) {
      if (sourceEvent == "click") {
        if (expanded.length > 2) {
          let clientId = expanded[2];
          window.location.href = `/clients/${clientId}`;
        }
      }
    },
    goBack: function() {
      this.$router.replace("/clients");
    },
    editCompany() {
      // this.$router.replace("edit/" + this.clientDescription.id);
      let clientId = this.clientDescription.id;
      this.$router.push({ path: `edit/${clientId}` });
    },
    showSatelliteOffice() {
      // console.log(this.satelliteOffices);
      // const keysSorted = Object.keys(this.satelliteOffices).sort(function(a,b){return b-a})
      var sat = this.satelliteOffices
      var ordered = {};   
      _(sat).keys().sort().each(function (key) {
        ordered[key] = sat[key];
      });
      this.satelliteOfficeHistoryData = ordered;
      // var result = _.pickBy(this.satelliteOffices, function(value, key) {
      //   return _.startsWith(key, id);
      // });
      // console.log(result[id])
      // this.satelliteOfficeHistoryData = result[id];
      this.satellitePopupActive = true;
      // console.log(result)
      // console.log(Object.filter(this.satelliteOffices, [id], true))
      // console.log(typeof this.satelliteOffices);
      // this.satelliteOfficeHistoryData = this.satelliteOffices.filter(ele => {
      //   console.log(ele)
      // })
    },
    getSatellite() {
      this.$store
        .dispatch(
          "clientsManagement/getSatelliteOfficeMetaData",
          this.clientDescription.id
        )
        .then(res => {
          var result = res.data;
          this.satelliteOffices = result.reduce((res, curr) => {
            if (res[curr.transaction_id]) res[curr.transaction_id].push(curr);
            else Object.assign(res, { [curr.transaction_id]: [curr] });

            return res;
          }, {});
        })
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.metadata = [];
          //   return;
          // }
          console.error(err);
        });
    },
    showMasterSatelliteOffice() {
      this.popupActive = false;
      this.satellitePopupActive = true;
      // this.showSatelliteMetaData("masterSatellite", "Satellite Office");
    },
    convertTime(apiTime) {
      // date = Date.parse(apiTime)
      let date = new Date(apiTime);
      return date.toLocaleString();
    },
    showGroupCompanies() {
      const parentId = this.clientDescription.parent;
      this.$store
        .dispatch("clientsManagement/getGroupCompanies", parentId)
        .then(res => {
          this.groupCompanies = JSON.parse(
            JSON.parse(JSON.stringify(res.data))
          );
          this.groupCompanies = this.groupCompanies.map(ele => {
            ele.id = ele.children_id;
            ele.label = ele.children_name;
            return ele;
          });
          this.companyTree = {
            id: "root",
            children: [
              {
                id: "companies",
                label: this.parent_name,
                children: this.groupCompanies
              }
            ]
          };
          return;
        })
        .catch(err => {
          if (err.status === 404) {
            this.groupCompanies = [];
            return;
          }
          console.error(err);
        });
      this.showGroupCompaniesButton = false;
    },
    getRegistrationJurificationName(countryId) {
      return this.$store
        .dispatch("clientsManagement/getCountry", countryId)
        .then(res => res.data)
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.clientDescription.res = true;
          //   return;
          // }
          console.error(err);
        });
    },
    getParentName(parentId) {
      return this.$store
        .dispatch("clientsManagement/getParent", parentId)
        .then(res => res.data)
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    showParentName(parentId) {
      this.$store
        .dispatch("clientsManagement/getParent", parentId)
        .then(res => {
          this.parent_name = res.data.company_name;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("clientsManagement/getCountry", countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    getVerticalName(verticalId) {
      return this.$store
        .dispatch("clientsManagement/getVertical", verticalId)
        .then(res => res.data)
        .catch(err => {
          // if (err.response.status === 404) {
          //   this.verticalName = true;
          //   return;
          // }
          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("clientsManagement/getVertical", verticalId)
        .then(res => {
          this.verticalName = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
